import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const ThemeContext = createContext(null);

const THEMES = [
  { id: 'midnight', name: 'Midnight', description: 'Dark, low-glare interface' },
  { id: 'slate', name: 'Slate Light', description: 'Light, high-contrast interface' },
];

export const ThemeProvider = ({ children }) => {
  const [theme, setThemeState] = useState(() => {
    try { return localStorage.getItem('casefile-theme') || 'midnight'; } catch { return 'midnight'; }
  });

  useEffect(() => {
    document.body.dataset.theme = theme;
    try { localStorage.setItem('casefile-theme', theme); } catch {}
  }, [theme]);

  const setTheme = (id) => {
    if (THEMES.find(t => t.id === id)) setThemeState(id);
  };

  const value = useMemo(() => ({ theme, setTheme, themes: THEMES }), [theme]); // eslint-disable-line react-hooks/exhaustive-deps

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) throw new Error('useTheme must be used within a ThemeProvider');
  return context;
};
